import localStyles from './styles.module.scss';
import styles from '../styles.module.scss';

import React, {useEffect, useRef, useState} from "react";
import {useAppData} from "../../context/Contexts";
import {useLocalStorage} from "../../hooks/useLocalStorage";

const Bonus3TitleSection: React.FC = (props) => {
    const {currentAppData, setCurrentAppData} = useAppData();
    const [source, setSource] = useLocalStorage("source", "");

    /*useEffect(() => {
        if (source == 'fb1') {
            setCurrentAppData(prevState => {
                return { ...prevState, with_bonus: true }
            })
        }
    }, [source]);

    function onChange() {
        setCurrentAppData(prevState => {
            return { ...prevState, with_bonus: !prevState?.with_bonus }
        })
    }*/

    //console.log('source=', source);

    return (
        <div className={`free_bonus ${localStyles.bonus3_title_section}`}>

            <div className={`${localStyles.title}`}>
                <strong>{`${props.title}`}</strong><span>{`${props.subtitle}`}</span></div>
        </div>
    );
};

export default Bonus3TitleSection;